import { path } from "src/utils/generalUtils";
import { isWindowPresent } from "src/utils/browserHelpers";
class RavenWebSDK {
  event = (ravenEventName: string, masterObject = {}) => {
    try {
      if (path(["ravenWebManager"], window)) {
        window.ravenWebManager.triggerRaven(ravenEventName, masterObject);
      } else {
        if (path(["ravenEarlyEventQueue"], window)) {
          window.ravenEarlyEventQueue.push({
            name: ravenEventName,
            payload: masterObject,
          });
        } else if (!isWindowPresent) {
          window.ravenEarlyEventQueue = [];
          window.ravenEarlyEventQueue.push({
            name: ravenEventName,
            payload: masterObject,
          });
        }
        console.info(
          "Raven: Error in sending data to Raven, SDK not initialized. Event : ",
          ravenEventName
        );
      }
    } catch (error) {
      console.info("Raven: Error in sending data to Raven", error);
    }
  };
}
const RavenWebManager = new RavenWebSDK();
export default RavenWebManager;
